import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import RoleMenu from './views/RoleMenu.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{ path: '/login', name: 'Login', component: () => import('./views/Login.vue'), meta: { public: true } },
		{
			path: '/force-change-password',
			name: 'ForceChangePassword',
			component: () => import('./views/ForceChangePassword.vue'),
			meta: { title: '修改密码', allowMustChange: true }
		},
		{
			path: '/',
			component: () => import('./views/Layout.vue'),
			children: [
				{ path: '', redirect: '/portal' },
				{ path: 'portal', name: 'Portal', component: () => import('./views/Portal.vue'), meta: { title: '应用门户' } },
				{ path: 'portal/finance', name: 'FinancePortal', component: () => import('./views/FinancePortal.vue'), meta: { title: '财务系统' } },
				{ path: 'profile', name: 'Profile', component: () => import('./views/Profile.vue'), meta: { title: '个人信息', allowMustChange: true } },
				{ path: 'orgs', name: 'OrgList', component: () => import('./views/orgs/OrgList.vue'), meta: { title: '组织结构' } },
				{ path: 'orgs/:id', name: 'OrgDetail', component: () => import('./views/orgs/OrgDetail.vue'), meta: { title: '组织详情' } },
				{ path: 'users', name: 'UserList', component: () => import('./views/users/UserList.vue'), meta: { title: '用户管理' } },
				{ path: 'users/:id', name: 'UserDetail', component: () => import('./views/users/UserDetail.vue'), meta: { title: '用户详情' } },
				{ path: 'grants', name: 'Grants', component: () => import('./views/Grants.vue'), meta: { title: '数据穿透' } },
				{ path: 'platform', name: 'Platform', component: () => import('./views/Platform.vue'), meta: { title: '平台管理', platformOnly: true } },
				{ path: 'platform/message-policy', name: 'MessagePolicy', component: () => import('./views/MessagePolicy.vue'), meta: { title: '消息路由策略', platformOnly: true } },
				{ path: 'platform/api-key-usage', name: 'ApiKeyUsage', component: () => import('./views/ApiKeyUsage.vue'), meta: { title: 'API Key 用量统计', platformOnly: true } },
				{ path: 'role-menu', name: 'RoleMenu', component: RoleMenu, meta: { title: '角色菜单', platformOnly: true } },
				{ path: 'settings', name: 'Settings', component: () => import('./views/Settings.vue'), meta: { title: '系统设置' } },
				{ path: 'audit', name: 'AuditLogs', component: () => import('./views/AuditLogs.vue'), meta: { title: '操作审计', platformOnly: true } },
				{ path: 'ui-config', name: 'UiConfig', component: () => import('./views/UiConfig.vue'), meta: { title: '移动端配置', platformOnly: true } }
			]
		}
	]
});

// 会话恢复标记：pf 等业务系统用 window.location 硬跳回 org-auth(/portal、/profile)时，
// SPA 全新加载，vuex currentUser 为空。需用共享 sa-token cookie 调一次 /me 恢复登录态，
// 否则路由守卫会误判未登录、把已登录用户弹回 /login。仅尝试一次，避免每次站内跳转都打 /me。
let sessionRestored = false;

router.beforeEach(async (to, from, next) => {
	document.title = '竹溪县商旅综合体物业管理系统';
	if (to.meta.public) return next();
	if (!store.getters.isLogin && !sessionRestored) {
		// 告知 axios 401 拦截器本次 401 由守卫接管，不要抢先 router.replace 造成导航冲突
		window.__ORG_AUTH_BOOT_RESTORE__ = true;
		try {
			await store.dispatch('refreshMe');
			sessionRestored = true;
		} catch (e) {
			// 仅 401 视为会话死亡；网络/menus 失败不置 sessionRestored，下次导航再试（F-3）
			if (e && e.status === 401) sessionRestored = true;
		} finally {
			window.__ORG_AUTH_BOOT_RESTORE__ = false;
		}
	}
	if (!store.getters.isLogin) return next({ path: '/login', query: { redirect: to.fullPath } });
	// 强制改密闸：除改密相关页外一律重定向
	const mustChange = !!(store.state.currentUser && store.state.currentUser.mustChangePassword);
	if (mustChange && !to.meta.allowMustChange && to.name !== 'ForceChangePassword') {
		return next({ path: '/force-change-password' });
	}
	if (!mustChange && to.name === 'ForceChangePassword') {
		return next({ path: '/portal' });
	}
	if (to.meta.platformOnly && !store.getters.isPlatformAdmin) {
		HeyUI.$Message.error('仅平台管理员可访问');
		return next('/portal');
	}
	// IK8CPE L2：直链/书签进账套门户时，无有效做账权则拦回应用门户
	if (to.name === 'FinancePortal') {
		const financeMenu = (store.state.menus || []).find(m => m && m.id === 'finance');
		if (financeMenu && financeMenu.locked) {
			HeyUI.$Message.warn('无做账权限，无法进入财务账套门户。请联系管理员在账套中授予做账角色。');
			return next({ path: '/portal', replace: true });
		}
	}
	next();
});

export default router;
